import type { FC } from "react";
import type { SessionEducationalResourceItem } from "../../interfaces/sessionDetails";
import { SessionResourceList } from "./SessionResourceList";

type SessionWorksheetsSectionProps = {
  items: SessionEducationalResourceItem[];
};

export const SessionWorksheetsSection: FC<SessionWorksheetsSectionProps> = ({
  items,
}) => (
  <SessionResourceList
    titleKey="session_worksheets"
    titleFallback="Worksheets"
    items={items}
    emptyKey="session_no_worksheets"
    emptyFallback="No worksheets for this session."
  />
);
